<section class="login">
  <img src="assets/images/mynteLogo.svg" class="mynte-logo" />
  <button class="msal-login pointer" (click)="login()">
    <img src="assets/images/microsoft_logo.svg" alt="Microsoft logo" class="msal-logo" />
    Inloggen met Microsoft
  </button>
</section>
